import { ApiError } from '@jq4race/api-client';

/**
 * True when `error` is an `ApiError` carrying HTTP 403 (Forbidden).
 *
 * Root cause this guards against (confirmed via production audit): the
 * backend re-derives the caller's role from the database on every request
 * (`tenant.interceptor.ts`) instead of trusting a possibly-stale JWT, so a
 * user whose role changed mid-session gets a 403 the moment they try an
 * action their NEW role doesn't allow. Without this check, a list page's
 * generic `catch` block renders that 403 identically to "there is no data"
 * — see EventsPage.tsx for the confirmed incident.
 *
 * Used to:
 *  - swap a list's empty state for `AccessDeniedState` instead of "0 items".
 *  - mark the resulting error banner as persistent, so it isn't
 *    auto-dismissed like a transient error would be (see
 *    useAutoDismissFeedback).
 */
export function isForbiddenError(error: unknown): boolean {
  return error instanceof ApiError && error.status === 403;
}
